import RatingStars from '@components/product/ProductRatingStars';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import trackBazaarvoiceEvent from '@utils/gtm/ga4/trackBazaarvoiceEvents';

import styles from './ProductBuySectionReviews.module.scss';

export interface ProductBuySectionReviewsProps {
  productReviewData: {
    numberOfReviews: number;
    summationOfRatings: number;
  };
  handleClick: () => void;
  productName: string;
}

const ProductBuySectionReviews = ({
  productReviewData,
  handleClick,
  productName,
}: ProductBuySectionReviewsProps) => {
  const { t } = useTranslation('pdp');
  const { isFallback } = useRouter();

  const handleStarsClick = () => {
    trackBazaarvoiceEvent('Review stars');
    handleClick();
  };

  return (
    <button
      type="button"
      title={
        productReviewData?.numberOfReviews === 0
          ? `${t('product.review.button.title')} ${productName}`
          : `${productReviewData?.summationOfRatings} ${t(
              'product.reviews.link.description.1'
            )} ${productReviewData?.numberOfReviews} ${t(
              'product.reviews.link.description.2'
            )} ${productName}`
      }
      className={styles.reviewsButton}
      onClick={handleStarsClick}
    >
      <RatingStars rating={productReviewData?.summationOfRatings} />
      {productReviewData?.numberOfReviews > 0 ? (
        <span
          className={styles.ratingCount}
        >{`(${productReviewData?.numberOfReviews})`}</span>
      ) : (
        <span className={styles.writeReview}>
          {!isFallback && t('product.write.a.review')}
        </span>
      )}
    </button>
  );
};

export default ProductBuySectionReviews;
